import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentoCabeceraService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) {

  }

  public insertar_relacion_hash(objects: any) {
    return this.http.post(environment.serviceUrl + "documento-relacion-hash/v2", objects, { observe: 'response' },)
  }


  getListDetallesPendientes(numints: string) {
    this.apiService.setUrlPathApi('documento-generico/detalle-pendiente?');
    return this.apiService.execGetQueryJson(`numints=${numints}`);
    //return this.http.get(`${this.clienteService.getUrlSession().urlService}/documento-generico/detalle-pendiente?numints=${numints}`, { observe: 'response' });
  }

  getListDetallesPendientesAgrupado(numints: string) {
    this.apiService.setUrlPathApi('documento-generico/detalle-pendiente-agrupado?');
    return this.apiService.execGetQueryJson(`numints=${numints}`);
    //return this.http.get(`${this.clienteService.getUrlSession().urlService}/documento-generico/detalle-pendiente?numints=${numints}`, { observe: 'response' });
  }



  public obtener(tipdoc: number, numint: number) {
    if (tipdoc == 1) {
      return this.http.get(environment.serviceUrl + "factura/" + numint, { observe: 'response' },)
    } else if (tipdoc == 3) {
      return this.http.get(environment.serviceUrl + "boleta/" + numint, { observe: 'response' },)
    } else if (tipdoc == 7) {
      return this.http.get(environment.serviceUrl + "nota-credito/" + numint, { observe: 'response' },)
    } else if (tipdoc == 8) {
      return this.http.get(environment.serviceUrl + "nota-debito/" + numint, { observe: 'response' },)
    } else if (tipdoc == 108) {
      return this.http.get(environment.serviceUrl + "guiaRecepcion/" + numint, { observe: 'response' },)
    }
  }

  public insertar(tipdoc: number, object: any) {
    if (tipdoc == 1) {
      return this.http.post(environment.serviceUrl + "factura/", object, { observe: 'response' },)
    } else if (tipdoc == 3) {
      return this.http.post(environment.serviceUrl + "boleta/", object, { observe: 'response' },)
    } else if (tipdoc == 7) {
      return this.http.post(environment.serviceUrl + "nota-credito/", object, { observe: 'response' },)
    } else if (tipdoc == 8) {
      return this.http.post(environment.serviceUrl + "nota-debito/", object, { observe: 'response' },)
    }
  }

  public calcularTotales(tipdoc: number, object: any) {
    if (tipdoc == 1) {
      return this.http.put(environment.serviceUrl + "factura/calcular", object, { observe: 'response' },)
    } else if (tipdoc == 3) {
      return this.http.put(environment.serviceUrl + "boleta/calcular", object, { observe: 'response' },)
    } else if (tipdoc == 7) {
      return this.http.put(environment.serviceUrl + "nota-credito/calcular", object, { observe: 'response' },)
    } else if (tipdoc == 8) {
      return this.http.put(environment.serviceUrl + "nota-debito/calcular", object, { observe: 'response' },)
    }
  }

  public actualizar(tipdoc: number, object: any) {
    if (tipdoc == 1) {
      return this.http.put(environment.serviceUrl + "factura/", object, { observe: 'response' },)
    } else if (tipdoc == 3) {
      return this.http.put(environment.serviceUrl + "boleta/", object, { observe: 'response' },)
    } else if (tipdoc == 7) {
      return this.http.put(environment.serviceUrl + "nota-credito/", object, { observe: 'response' },)
    } else if (tipdoc == 8) {
      return this.http.put(environment.serviceUrl + "nota-debito/", object, { observe: 'response' },)
    }
  }


  public anular(tipdoc: number, numint: number, coduser: string) {
    if (tipdoc == 1) {
      return this.http.put(environment.serviceUrl + "factura/" + numint + "/anular?coduser=" + coduser, null, { observe: 'response' },)
    } else if (tipdoc == 3) {
      return this.http.put(environment.serviceUrl + "boleta/" + numint + "/anular?coduser=" + coduser, null, { observe: 'response' },)
    } else if (tipdoc == 7) {
      return this.http.put(environment.serviceUrl + "nota-credito/" + numint + "/anular?coduser=" + coduser, null, { observe: 'response' },)
    } else if (tipdoc == 8) {
      return this.http.put(environment.serviceUrl + "nota-debito/" + numint + "/anular?coduser=" + coduser, null, { observe: 'response' },)
    } else {
      return null;
    }
  }
  public anular_v2(tipdoc: number, numint: number, comentario: string) {
    if (tipdoc == 1) {
      return this.http.put(environment.serviceUrl + "factura/" + numint + "/v2/anular?comentario=" + comentario, null, { observe: 'response' },)
    } else if (tipdoc == 3) {
      return this.http.put(environment.serviceUrl + "boleta/" + numint + "/v2/anular?comentario=" + comentario, null, { observe: 'response' },)
    } else if (tipdoc == 7) {
      return this.http.put(environment.serviceUrl + "nota-credito/" + numint + "/v2/anular?comentario=" + comentario, null, { observe: 'response' },)
    } else if (tipdoc == 8) {
      return this.http.put(environment.serviceUrl + "nota-debito/" + numint + "/v2/anular?comentario=" + comentario, null, { observe: 'response' },)
    } else {
      return null;
    }
  }

  public eliminar(tipdoc: number, numint: number, coduser: string) {
    if (tipdoc == 1) {
      return this.http.put(environment.serviceUrl + "factura/" + numint + "/eliminar?coduser=" + coduser, null, { observe: 'response' },)
    } else if (tipdoc == 3) {
      return this.http.put(environment.serviceUrl + "boleta/" + numint + "/eliminar?coduser=" + coduser, null, { observe: 'response' },)
    } else if (tipdoc == 7) {
      return this.http.put(environment.serviceUrl + "nota-credito/" + numint + "/eliminar?coduser=" + coduser, null, { observe: 'response' },)
    } else if (tipdoc == 8) {
      return this.http.put(environment.serviceUrl + "nota-debito/" + numint + "/eliminar?coduser=" + coduser, null, { observe: 'response' },)
    } else {
      return null;
    }
  }

  // pendiente en implementacion
  download_pdf(tipdoc: number, id_cia: number, numint: number) {
    let fullUrl: any = null;
    if (tipdoc == 1) {
      fullUrl = environment.serviceUrl_Report + `factura/${id_cia}/${numint}/pdf/format-default.pdf?`;
    } else if (tipdoc == 3) {
      fullUrl = environment.serviceUrl_Report + `boleta/${id_cia}/${numint}/pdf/format-default.pdf?`;
    } else if (tipdoc == 7) {
      fullUrl = environment.serviceUrl_Report + `nota-credito/${id_cia}/${numint}/pdf/format-default.pdf`;
    } else if (tipdoc == 8) {
      fullUrl = environment.serviceUrl_Report + `nota-debito/${id_cia}/${numint}/pdf/format-default.pdf`;
    }
    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }
  download_pdfAgrup(tipdoc: number, id_cia: number, numint: number,agrupado:any) {
    let fullUrl: any = null;
    if (tipdoc == 1) {
      fullUrl = environment.serviceUrl + `factura/${id_cia}/${numint}/pdf/format-default.pdf?agrupado=${agrupado}`;
    } else if (tipdoc == 3) {
      fullUrl = environment.serviceUrl + `boleta/${id_cia}/${numint}/pdf/format-default.pdf?agrupado=${agrupado}`;
    } else if (tipdoc == 7) {
      fullUrl = environment.serviceUrl + `nota-credito/${id_cia}/${numint}/pdf/format-default.pdf?agrupado=${agrupado}`;
    } else if (tipdoc == 8) {
      fullUrl = environment.serviceUrl + `nota-debito/${id_cia}/${numint}/pdf/format-default.pdf?agrupado=${agrupado}`;
    }
    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }
  
  // pendiente en implementacion
  download_ticket_pdf(tipdoc: number, id_cia: number, numint: number) {
    let fullUrl: any = null;
    if (tipdoc == 1) {
      fullUrl = environment.serviceUrl + `factura/${id_cia}/${numint}/pdf/format-ticket.pdf?`;
    } else if (tipdoc == 3) {
      fullUrl = environment.serviceUrl + `boleta/${id_cia}/${numint}/pdf/format-ticket.pdf?`;
    } else if (tipdoc == 7) {
      fullUrl = environment.serviceUrl + `nota-credito/${id_cia}/${numint}/pdf/format-ticket.pdf`;
    } else if (tipdoc == 8) {
      fullUrl = environment.serviceUrl + `nota-debito/${id_cia}/${numint}/pdf/format-ticket.pdf`;
    }


    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }


  public descargarXML(id_cia: number, numint: number) {
    this.apiService.setUrlPathApiReport("consultas-fe/cpe");
    return this.apiService.execGetQueryJsonPDF(`/${id_cia}/${numint}/sunat-xml.zip`).pipe();
  }

  public descargarCDR(id_cia: number, numint: number) {
    this.apiService.setUrlPathApiReport("consultas-fe/cpe");
    return this.apiService.execGetQueryJsonPDF(`/${id_cia}/${numint}/sunat-cdr.zip`).pipe();
  }


  obtenerNumeroDocumento(tipdoc: number, serie: string): Observable<any> {
    this.apiService.setUrlPathApi('documentoCab');
    return this.apiService.execGetQueryJson(`/obtenerNumdoc?tipdoc=${tipdoc}&serie=${serie}`).pipe();
  }

  obtenerUltimoNumeroDocumento(tipdoc: number, serie: string): Observable<any> {
    this.apiService.setUrlPathApi('documentoCab');
    return this.apiService.execGetQueryJson(`/obtener-ultimo-nro-documento?tipdoc=${tipdoc}&serie=${serie}`).pipe();
  }

  obtenerDocumento(tipdoc: number, serie: string, number: number): Observable<any> {
    this.apiService.setUrlPathApi('documentoCab');
    return this.apiService.execGetQueryJson(`/${tipdoc}?serie=${serie}&numdoc=${number}`).pipe();
  }


  public obtener_anticipo_det(factura: any) {
    return this.http.put(environment.serviceUrl + "factura/anticipo-det", factura, { observe: 'response' },)
  }

  public obtener_anticipo_det_boleta(boleta: any) {
    return this.http.put(environment.serviceUrl + "boleta/anticipo-det", boleta, { observe: 'response' },)
  }



}
